import React, { useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { Box, CircularProgress } from '@mui/material'
import { useAppSelector, useAppDispatch } from '../../hooks/redux'
import { loginSuccess } from '../../store/slices/authSlice'
import { authService } from '../../services/auth'

interface ProtectedRouteProps {
  children: React.ReactNode
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const dispatch = useAppDispatch()
  const { isAuthenticated, isLoading } = useAppSelector((state) => state.auth)

  useEffect(() => {
    // Check if we have stored auth data but not authenticated in Redux
    if (!isAuthenticated) {
      if (authService.isAuthenticated()) {
        const user = authService.getUser()
        const token = authService.getToken()
        
        if (user && token) {
          dispatch(loginSuccess({ user, token }))
        }
      }
    }
  }, [isAuthenticated, dispatch])

  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    )
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated || !authService.isAuthenticated()) {
    return <Navigate to="/auth/login" replace />
  }

  return <>{children}</>
}